
import Swiper, { Navigation, HashNavigation } from 'swiper';
Swiper.use([Navigation, HashNavigation]);

import Component from 'gia/Component'

export default class SwiperComponent extends Component {

  // pagination = '.swiper-pagination'
  next = '.swiper-button-next'
  prev = '.swiper-button-prev'

  constructor(element) {
    super(element);
    this.ref = {
      next: null,
      prev: null
    }
  }

  mount() {
    const swiper = new Swiper(this.element, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 60,
      hashNavigation: {
        replaceState: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 30
        },
        1280: {
          spaceBetween: 0
        }
      },
      loop: true,
      navigation: {
        nextEl: this.next,
        prevEl: this.prev
      },

    });


  }
}



